// extracted by mini-css-extract-plugin
export default {"btn_delete":"Buttons_btn_delete__m7e98","btn_edit":"Buttons_btn_edit__FBnfg","btn_add":"Buttons_btn_add__Qz4I0"};